import { useContext } from 'react';

import TownConfigContext from './TownConfigContext';

const useTownConfig = () => {
  const context = useContext(TownConfigContext);
  if (context === null) {
    throw new Error('useTownConfig must be used within a TownConfigProvider');
  }
  return context;
};

export default useTownConfig;
